import React, { useState } from "react";
import { InputAdornment, TextField, Typography } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { IconButton } from "@mui/material";

const PasswordField = ({ placeholder, value, onChange, ...props }) => {
  const [showPassword, setShowPassword] = useState(false);
  const [isCapsLockOn, setIsCapsLockOn] = useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handlePasswordKeyPress = (event) => {
    const { key, keyCode } = event;
    if (keyCode === 20) {
      setIsCapsLockOn((prev) => !prev);
    } else {
      const isUpperCase = key === key.toUpperCase() && key !== key.toLowerCase();
      setIsCapsLockOn(event.getModifierState("CapsLock") || (isUpperCase && !event.shiftKey));
    }
  };

  return (
    <>
      <TextField
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onKeyDown={handlePasswordKeyPress}
        sx={props.sx}
        type={showPassword ? "text" : "password"}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton aria-label="toggle password visibility" onClick={handleClickShowPassword} onMouseDown={handleMouseDownPassword} edge="end">
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
      {
        isCapsLockOn && (
          <Typography variant="subtitle1" sx={{ color: "#FFA500" }}>
            Caps Lock is ON
          </Typography>
        )
      }</>
  );
};

export default PasswordField;
